import * as SliderPrimitive from '@radix-ui/react-slider'
import * as React from 'react'

import { cn } from '@/lib/utils'

const RangeSlider = React.forwardRef<
  React.ComponentRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, orientation = 'horizontal', inverted, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    orientation={orientation}
    inverted={inverted}
    className={cn(
      'relative flex touch-none select-none items-center',
      orientation === 'vertical' ? 'h-full w-6 justify-center' : 'w-full',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        'relative grow overflow-hidden rounded-full bg-secondary',
        orientation === 'vertical' ? 'w-2 h-full' : 'h-2 w-full',
      )}
    >
      <SliderPrimitive.Range className={cn('absolute bg-primary', orientation === 'vertical' ? 'w-full' : 'h-full')} />
    </SliderPrimitive.Track>
    {(props.defaultValue || props.value || [0])?.map((_, i) => (
      <SliderPrimitive.Thumb
        key={i}
        className="relative block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 before:absolute before:content-[''] before:-inset-3 before:rounded-full"
      />
    ))}
  </SliderPrimitive.Root>
))
RangeSlider.displayName = SliderPrimitive.Root.displayName

export { RangeSlider, RangeSlider as Slider }
